import axiosInstance from '@/shared/api/axiosInstance';

export const getScheduleCard = (page = 0, size = 3, accessType) => {
    return axiosInstance.get('/game-card-schedules', {
        params: {
            page,
            size,
            accessType,
        }
    });
}

